import React, { useCallback } from "react";
import { FixedSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Scrollbars } from "react-custom-scrollbars";

// material-ui
import { makeStyles } from "@material-ui/core/styles";
import styles from "./styles-mui.js";

// styles
import {
  HeaderTextContainer,
  TableHeaderContainerStyled,
  TableBodyContainerStyled,
  TableHeaderColumnStyled,
} from "./styles";

// @material-ui/icons
import LocalShipping from "@material-ui/icons/LocalShipping";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";

// components
import PriceItemList from "components/PriceItemList";

const useStyles = makeStyles(styles);

const CustomScrollbars = ({ onScroll, forwardedRef, style, children }) => {
  const refSetter = useCallback(
    (scrollbarsRef) => {
      if (scrollbarsRef) {
        forwardedRef(scrollbarsRef.view);
      } else {
        forwardedRef(null);
      }
    },
    [forwardedRef]
  );

  return (
    <Scrollbars
      ref={refSetter}
      style={{ ...style, overflow: "hidden" }}
      onScroll={onScroll}
    >
      {children}
    </Scrollbars>
  );
};
const CustomScrollbarsVirtualList = React.forwardRef((props, ref) => (
  <CustomScrollbars {...props} forwardedRef={ref} />
));

const listRef = React.createRef();
const outerRef = React.createRef();

export default function UnitsSyncList({
  color,
  colorRGB,
  prices,
  ...listProps
}) {
  const classes = useStyles();

  return (
    <GridContainer className={classes.grid}>
      <GridItem className={classes.gridNoPadding} xs={12} sm={12} md={12}>
        <Card login className={`  ${classes.hFull} `}>
          <CardHeader color={color} text className={classes.cardHeaderHover}>
            <CardText className={classes.cardHeader} color={color}>
              <HeaderTextContainer>
                <LocalShipping />
                <h5 className={classes.cardTitle}>Actualización de precios</h5>
              </HeaderTextContainer>
            </CardText>
          </CardHeader>
          <CardBody className={classes.cardNoPadding}>
            <TableHeaderContainerStyled color={colorRGB}>
              <TableHeaderColumnStyled width={25}>
                <span>Producto</span>
              </TableHeaderColumnStyled>
              <TableHeaderColumnStyled width={25}>
                <span>Planta</span>
              </TableHeaderColumnStyled>
              <TableHeaderColumnStyled width={20}>
                <span>Precio índice</span>
              </TableHeaderColumnStyled>
              <TableHeaderColumnStyled width={20}>
                <span>Precio</span>
              </TableHeaderColumnStyled>
              <TableHeaderColumnStyled width={10}>
                <span></span>
              </TableHeaderColumnStyled>
            </TableHeaderContainerStyled>
            <TableBodyContainerStyled>
              <AutoSizer>
                {({ height, width }) => (
                  <List
                    ref={listRef}
                    className={classes.List}
                    height={height}
                    itemData={{
                      prices,
                      color,
                      ...listProps,
                    }}
                    itemCount={prices.length}
                    itemSize={40}
                    width={width}
                    outerElementType={CustomScrollbarsVirtualList}
                    outerRef={outerRef}
                  >
                    {PriceItemList}
                  </List>
                )}
              </AutoSizer>
            </TableBodyContainerStyled>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
